import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '@components/logo/Logo';

const LoginLayout: FC = (): ReactElement => {
  const { t: translate } = useTranslation();

  return (
    <div className="flex flex-col items-center sm:text-center lg:items-start">
      <div className="flex items-start sm:justify-center lg:justify-start">
        <Logo className="h-16 w-28 pl-1 sm:pl-0" />
      </div>
      <div className="sm:mt-2">
        <span className="mt-2 text-center text-2xl font-semibold text-primary-800 lg:text-start">
          {translate('loginPage.headings.welcome')}
        </span>
        <p className="text-md pt-3 text-center text-gray-400 lg:text-start">
          {translate('loginPage.headings.welcomeMsg')}
        </p>
      </div>
    </div>
  );
};

export default LoginLayout;
